import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Link,
} from "@mui/material";

const isImageUrl = (url) => {
  if (!url) return false;
  return (
    url.includes("cloudinary") ||
    /\.(png|jpg|jpeg|gif|webp)(\?.*)?$/i.test(url)
  );
};

const SubmissionLinksDialog = ({ open, onClose, submission }) => {
  const links = submission?.submissionLinks || [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>제출한 링크</DialogTitle>
      <DialogContent dividers>
        {links.length === 0 ? (
          <Typography color="text.secondary">제출된 링크가 없습니다.</Typography>
        ) : (
          links.map((item, index) => (
            <Box key={index} sx={{ mb: 3 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                {item.title}
              </Typography>
              {item.detail && (
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  {item.detail}
                </Typography>
              )}
              {isImageUrl(item.link) ? (
                <Box
                  component="img"
                  src={item.link}
                  alt={item.title}
                  sx={{
                    maxWidth: "100%",
                    maxHeight: 300,
                    objectFit: "contain",
                    borderRadius: 1,
                    border: "1px solid",
                    borderColor: "divider",
                  }}
                />
              ) : (
                <Link href={item.link} target="_blank" rel="noopener noreferrer" sx={{ wordBreak: "break-all" }}>
                  {item.link}
                </Link>
              )}
            </Box>
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>닫기</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubmissionLinksDialog;
